import React,{useState} from 'react'
import Sidebar from './Sidebar'
import phone from "../images/svg/phone.svg"
import sarvoday from "../images/sarvoday.png"
import phone_white from "../images/svg/svg1/phone-white.svg"
import menu from "../images/svg/menu.svg"
import menu_white from "../images/svg/svg1/menu-white.svg"
import Button from './Button'
const Nav = (props) => {
    const [sidebar,isSidebar]=useState(false);
  if(props.color){
    return (
    <nav className="z-50 flex flex-row justify-between px-4 pt-4 border-b-4 border-[#d2a960] bg-black ">
        <div className="flex p-4 place-self-center" onClick={()=> sidebar?isSidebar(false):isSidebar(true)}>
   <img src={menu} height="30px" width="30px" alt="menu"/>
    {sidebar && (<div className="py-8"><Sidebar/></div>)}
    <div className="px-6 flex flex-row">
    <img src={phone} height="30px" width="30px" alt="phone"/></div>
  </div>
  

  <div className="flex flex-row place-self-center">
   <div className="p-4">
       <img src={sarvoday} height="40px" width="50px" alt="logo"/>
    </div>
    <div>
    <div className="flex flex-col py-6"><div>
      <h4 className="text-xl font-medium text-white">HOTEL</h4></div>
    <div><h3 className="text-2xl font-bold text-white">SHARVODAY</h3></div></div>
  </div></div>
  
  <div className="p-4 place-self-center">
  <Button isColour="chrome" label="BOOK NOW"/></div>
</nav>
  )
  }
  else{
  return (
    <nav className="z-50 flex flex-row justify-between px-4 pt-4 bg-transparent">
        <div className="flex p-4 place-self-center" onClick={()=> sidebar?isSidebar(false):isSidebar(true)}>
   <img src={menu_white} width="30px" height="30px" alt="menu"/>
    {sidebar && (<div className="py-8"><Sidebar/></div>)}
    <div className="px-6 flex flex-row">
    <img src={phone_white} height="30px" width="30px" alt="phone"/></div>
  </div>
  

  <div className="flex flex-row place-self-center">
   <div className="p-4">
       <img src={sarvoday} height="40px" width="50px" alt="logo"/>
    </div>
    <div>
    <div className="flex flex-col py-6"><div>
      <h4 className="text-xl font-medium text-white">HOTEL</h4></div>
    <div><h3 className="text-2xl font-bold text-white">SHARVODAY</h3></div></div>
  </div></div>
  
  <div className="p-4 place-self-center">
  <Button isColor={false} label="BOOK NOW"/></div>
</nav>
  )
  }
}

export default Nav